import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "/api",
  withCredentials: true,   
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to attach token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.config?.url !== "/auth/login") {
      window.dispatchEvent(new Event("clock:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
